module.exports = __webpack_public_path__ + "img-background.bb0285c1de8db6799f38.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/assets/images/img-background.jpg
// module id = ../../../../../src/assets/images/img-background.jpg
// module chunks = main